import React, { useState } from "react";
import { useTranslation } from "react-i18next";
import {
  Button,
  Grid,
  GridRow,
  GridColumn,
  Header,
  Icon,
  Modal,
  ModalContent,
  ModalActions,
  TextArea,
} from "semantic-ui-react";

function SchedulingNotesModal({
  agencies,
  open,
  campaign,
  setModalOpen,
  selectedAssets,
  submitDigitalAssets,
}) {
  const { t } = useTranslation("common");
  const [additionalNotes, setAdditionalNotes] = useState("");
  const [submitList, setSubmitList] = useState([]);
  const [currentIndex, setCurrentIndex] = useState(0);

  const handleClose = () => {
    setCurrentIndex(0);
    setAdditionalNotes("");
    setSubmitList([]);
    setModalOpen(false);
  };

  const handleSubmit = (agencyId) => {
    const updatedSubmitList = [
      ...submitList,
      {
        agencyId: agencyId,
        additionalNotes: additionalNotes,
      },
    ];
    submitDigitalAssets(selectedAssets, updatedSubmitList);
    setCurrentIndex(0);
    setAdditionalNotes("");
    setSubmitList([]);
    setModalOpen(false);
  };

  const handleNext = (agencyId) => {
    setSubmitList([
      ...submitList,
      {
        agencyId: agencyId,
        additionalNotes: additionalNotes,
      },
    ]);
    setAdditionalNotes("");
    setCurrentIndex(currentIndex + 1);
  };

  const isLastModal = currentIndex === agencies.length - 1;

  return (
    <>
      {open && (
        <Modal key={currentIndex} open={open} size="small">
          <Header icon>
            <Icon name="envelope" />
            <Grid textAlign="left">
              <GridRow>
                <GridColumn width={6}>{t("campaign_scheduling_notes_modal_header")}</GridColumn>
                <GridColumn width={10}>{agencies[currentIndex].text}</GridColumn>
              </GridRow>
            </Grid>
          </Header>
          <ModalContent>
            <Grid>
              <GridRow>
                <GridColumn width={4}>
                  <label>{t("campaign_scheduling_notes_modal")}</label>
                </GridColumn>
                <GridColumn width={12} style={{ whiteSpace: "pre-wrap" }}>
                  {campaign.scheduling_notes}
                </GridColumn>
              </GridRow>
              <GridRow>
                <GridColumn width={4}>
                  <label>{t("campaign_scheduling_notes_modal_additional")}</label>
                </GridColumn>
                <GridColumn width={12}>
                  <TextArea
                    style={{
                      width: "100%",
                      borderColor: "#D8D8D8",
                      borderRadius: "4px",
                      whiteSpace: "pre-wrap",
                    }}
                    value={additionalNotes}
                    onChange={(e) => setAdditionalNotes(e.target.value)}
                  />
                </GridColumn>
              </GridRow>
            </Grid>
          </ModalContent>
          <ModalActions>
            <Button color="red" onClick={() => handleClose()}>
              <Icon name="remove" /> {t("cancel")}
            </Button>
            {isLastModal ? (
              <Button color="green" onClick={() => handleSubmit(agencies[currentIndex].value)}>
                <Icon name="checkmark" /> {t("submit")}
              </Button>
            ) : (
              <Button primary onClick={() => handleNext(agencies[currentIndex].value)}>
                <Icon name="right arrow" /> {t("next")}
              </Button>
            )}
          </ModalActions>
        </Modal>
      )}
    </>
  );
}

export default SchedulingNotesModal;
